import { application } from "./application"
import TomSelectController from "./tom_select_controller"
import ConfirmModalController from "./confirm_modal_controller"
import InputSecretController from "./input_secret_controller"
import CheckboxController from "./checkbox_controller"
import WaSignupController from "./wa_signup_controller"
import SessionTimeoutController from "./session_timeout_controller"
import MessagePreviewController from "./message_preview_controller"
import TinymceController from "./tinymce_controller"
import ButtonsController from "./buttons_controller"
import InputTagsController from "./input_tags_controller"
import ToggleController from "./toggle_controller"
import MoveableController from "./moveable_controller"
import SearchController from "./search_controller"
import TurboConversations from "./turbo_conversations"
import TurboMessages from "./turbo_messages"
import ResetForm from "./reset_form_controller"
import ConversationController from "./conversation_controller"
import ReplaceSrcController from "./replace_src_controller"
import HeaderMediaController from "./header_media_controller"
import CountCharsController from "./count_chars_controller"
import MessageLimitController from "./message_limit_controller"
import ToggleFieldController from "./toggle_field_controller"
import QrCodeController from "./qr_code_controller"
import DatetimeValidatorController from "./datetime_validator_controller"
import DateRangeController from "./date_range_controller"
import SimpleModalController from "./simple_modal_controller"
import ChartController from "./chart_controller"
import TooltipController from "./tooltip_controller"
import ToggleSubmitController from "./toggle_submit_controller"
import EnabledModulesController from "./enabled_modules_controller"
import RangeSliderController from "./range_slider_controller"
import ToggleOptionsController from "./toggle_options_controller"
import ComplianceAnswersSelectorController from "./compliance_answers_selector_controller"
import RadioCheckboxController from "./radio_checkbox_controller"
import ConfirmController from "./confirm_controller"
import StructuredOutputController from "./structured_output_controller"
import CloneProjectController from "./clone_project_controller"
import SupportTimesController from "./support_times_controller"
import OpenaiEndpointController from "./openai_endpoint_controller"
import ManualModelController from "./manual_model_controller"

application.register("tom-select", TomSelectController)
application.register("confirm-modal", ConfirmModalController)
application.register("input-secret", InputSecretController)
application.register("checkbox", CheckboxController)
application.register("wa-signup", WaSignupController)
application.register("session-timeout", SessionTimeoutController)
application.register("message-preview", MessagePreviewController)
application.register("tinymce", TinymceController)
application.register("buttons", ButtonsController)
application.register("input-tags", InputTagsController)
application.register("toggle", ToggleController)
application.register("moveable", MoveableController)
application.register("search", SearchController)
application.register("turbo-conversations", TurboConversations)
application.register("turbo-messages", TurboMessages)
application.register("reset-form", ResetForm)
application.register("conversation", ConversationController)
application.register("replace-src", ReplaceSrcController)
application.register("header-media", HeaderMediaController)
application.register("count-chars", CountCharsController)
application.register("message-limit", MessageLimitController)
application.register("toggle-field", ToggleFieldController)
application.register("qr-code", QrCodeController)
application.register("datetime-validator", DatetimeValidatorController)
application.register("date-range", DateRangeController)
application.register("simple-modal", SimpleModalController)
application.register("chart", ChartController)
application.register("tooltip", TooltipController)
application.register("toggle-submit", ToggleSubmitController)
application.register("enabled-modules", EnabledModulesController)
application.register("range-slider", RangeSliderController)
application.register("toggle-options", ToggleOptionsController)
application.register("compliance-answers-selector", ComplianceAnswersSelectorController)
application.register("radio-checkbox", RadioCheckboxController)
application.register("confirm", ConfirmController)
application.register("structured-output", StructuredOutputController)
application.register("clone-project", CloneProjectController)
application.register("support-times", SupportTimesController)
application.register("openai-endpoint", OpenaiEndpointController)
application.register("manual-model", ManualModelController)